import React, { FC, useState, useCallback } from 'react';

import { ReservationFlowMe } from 'src/interfaces/reservation_flow';
import { ProductPurchaseServiceContext } from 'src/contexts/state-machines/purchase/ProductPurchaseServiceContext';

import { VerifyView } from '../VerifyView';
import { ContentView } from '../ContentView';
import { MainView } from '../MainView';
import { ConfirmView } from '../ConfirmView';

export interface ViewHandlerProps {
  onRequireClosing: () => void;
  merchantPublicId: string;
  user: ReservationFlowMe;
  productPublicId?: number;
}

export const ViewHandler: FC<ViewHandlerProps> = ({
  onRequireClosing,
  merchantPublicId,
  user,
  productPublicId,
}) => {
  const [state] = ProductPurchaseServiceContext.useActor();

  // state machineの状態を更新しないViewはコンポーネント側でハンドリングする
  const [isPresentingContentView, setIsPresentingContentView] = useState(true);

  // ContentView
  const onContentViewRequireNext = useCallback(() => {
    setIsPresentingContentView(false);
  }, []);

  // MainView
  const onMainViewRequirePrev = useCallback(() => {
    setIsPresentingContentView(true);
  }, []);

  if (typeof productPublicId === 'undefined') {
    return null;
  }

  switch (true) {
    case state.matches('waitingForVerifying'):
      return (
        <VerifyView
          merchantPublicId={merchantPublicId}
          productPublicId={productPublicId}
          onRequireClosing={onRequireClosing}
        />
      );
    case state.matches('main'): {
      if (isPresentingContentView) {
        return (
          <ContentView
            onRequireClosing={onRequireClosing}
            onRequireNext={onContentViewRequireNext}
          />
        );
      }

      return <MainView onRequirePrev={onMainViewRequirePrev} user={user} />;
    }
    case state.matches('confirming'):
      return <ConfirmView />;
    default:
      return null;
  }
};
